// src/context/UserContext.jsx
import { createContext, useState, useEffect ,useCallback} from 'react';
import { validateToken } from '../utils/auth';
import CustomToast from '../pages/component-overview/Toast/CustomToast'

export const UserContext = createContext();

function loadStoredUser() {
    const raw = localStorage.getItem('data') || sessionStorage.getItem('data');
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

export const UserProvider = ({ children }) => {
    // 1. Initialize 'user' from localStorage for instant access.
    const [user, setUser] = useState(() => loadStoredUser());
    // 2. While we validate token, keep loading true.
    const [loading, setLoading] = useState(true);

    //===toasting
        const [toast, setToast] = useState(null); // new toast state
        const showToast = useCallback((message, type = 'info') => {
            setToast({ message, type });
        }, []);
    const closeToast = () => setToast(null);
  

    useEffect(() => {
        async function fetchUserAndValidate() {
            try {
                const data = await validateToken();
                if (data) {
                    setUser(data);
                    localStorage.setItem('data', JSON.stringify(data));
                    sessionStorage.setItem('data', JSON.stringify(data));
                } else {
                    setUser(null);
                }
            } catch (err) {
                console.error('User validation failed:', err);
                setUser(null);
                localStorage.removeItem('data');
            } finally {
                // Ensure loading is always set to false after the operation.
                setLoading(false);
            }
        }

        fetchUserAndValidate();
        
    }, []);

    return (
   
         <UserContext.Provider value={{ user, setUser, loading, showToast }}>
      {children}
      {toast && (
        <CustomToast
          message={toast.message}
          type={toast.type}
          onClose={closeToast}
        />
      )}
    </UserContext.Provider>
    );
};
